import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';

import { CLARET } from '../constants/colors';
import Container from './Container';

const StyledHeader = styled.div`
  background: ${CLARET};
  color: white;
  display: flex;
  align-items: center;
  font-family: Roboto, sans-serif;
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1.25rem;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  padding: 0.2em 0;
`;

const StyledContainer = styled(Container)`
  display: flex;
  align-items: center;
`;

const HomeLink = styled(Link)`
  color: inherit;
`;

const MenuWrapper = styled.div`
  font-size: 1rem;
  margin-left: auto;
`;

const MenuLink = styled(Link)`
  color: inherit;
`;

const Header = () => (
  <StyledHeader>
    <StyledContainer wide>
      <HomeLink to="/">Sławek Kołodziej</HomeLink>
      <MenuWrapper>
        <MenuLink to="/contact">Kontakt</MenuLink>
      </MenuWrapper>
    </StyledContainer>
  </StyledHeader>
);

export default Header;
